import React from 'react';
import clsx from 'clsx';

interface VoiceWaveformProps {
  bars: number[];
  // 0–1 share already played; those bars take the active colour.
  progress?: number;
  onSeek?: (ratio: number) => void;
  barClassName?: string;
  activeBarClassName?: string;
}

const VoiceWaveform: React.FC<VoiceWaveformProps> = ({
  bars,
  progress = 0,
  onSeek,
  barClassName = 'bg-grey60',
  activeBarClassName = 'bg-[#00A657]'
}) => {
  const playedBars = Math.round(progress * bars.length);

  return (
    <div
      className={clsx(
        'flex h-7 min-w-0 flex-1 items-center gap-0.5',
        onSeek && 'cursor-pointer'
      )}
      onClick={(event) => {
        if (!onSeek) return;
        const { left, width } = event.currentTarget.getBoundingClientRect();
        onSeek(Math.min(1, Math.max(0, (event.clientX - left) / width)));
      }}
      aria-hidden
    >
      {bars.map((level, index) => (
        <span
          // Bars are positional; they never reorder.
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          className={clsx(
            'w-0.5 shrink-0 rounded-full',
            index < playedBars ? activeBarClassName : barClassName
          )}
          style={{ height: `${Math.max(15, Math.round(level * 100))}%` }}
        />
      ))}
    </div>
  );
};

export default VoiceWaveform;
